import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Sparkles, LogOut, LayoutDashboard, Plus } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-slate-200/70 bg-white/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-blue-600 text-white shadow-sm group-hover:shadow-md transition-shadow">
            <Sparkles className="h-4 w-4" />
          </span>
          <span className="font-jakarta text-lg font-bold tracking-tight text-slate-900">
            AlternAI
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-600">
          <Link to="/#features" data-testid="nav-features" className="hover:text-slate-900 transition-colors">Fonctionnalités</Link>
          <Link to="/#pricing" data-testid="nav-pricing" className="hover:text-slate-900 transition-colors">Tarifs</Link>
          {user && <Link to="/dashboard" data-testid="nav-dashboard" className="hover:text-slate-900 transition-colors">Dashboard</Link>}
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              {pathname !== "/new" && (
                <Button asChild size="sm" className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-4">
                  <Link to="/new" data-testid="nav-cta-new">
                    <Plus className="h-4 w-4 mr-1.5" /> Nouvelle candidature
                  </Link>
                </Button>
              )}
              {pathname !== "/dashboard" && pathname !== "/new" && (
                <Button asChild variant="ghost" size="sm" className="text-slate-600">
                  <Link to="/dashboard" data-testid="nav-dashboard-btn">
                    <LayoutDashboard className="h-4 w-4 mr-1.5" /> Mes candidatures
                  </Link>
                </Button>
              )}
              <Button variant="ghost" size="sm" onClick={onLogout} data-testid="nav-logout" className="text-slate-500">
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          ) : (
            <>
              <Button asChild variant="ghost" size="sm" className="text-slate-700">
                <Link to="/login" data-testid="nav-login">Se connecter</Link>
              </Button>
              <Button asChild size="sm" className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-4 shadow-sm">
                <Link to="/register" data-testid="nav-register">Commencer</Link>
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
